import { memo } from 'react';

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import logoSrc from '@assets/brand/bloodhound-logo.png';
import appConfig from '@config/app.config';

/**
 * Official Bloodhound brand mark (dog + wordmark lockup).
 * `height` controls display size; width scales with the asset aspect ratio.
 */
const BrandMark = memo(function BrandMark({ height = 40, alt }) {
  const label = alt || appConfig.name;

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={label}
      sx={{
        display: 'block',
        height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        flexShrink: 0,
        borderRadius: 1,
        userSelect: 'none',
      }}
    />
  );
});

BrandMark.propTypes = {
  height: PropTypes.number,
  alt: PropTypes.string,
};

export default BrandMark;
